import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { useLanguage } from "@/context/LanguageContext";

export function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  const columns = [
    {
      title: t("footer_product"),
      links: [
        { label: t("nav_features"), to: "/#features" },
        { label: t("nav_calculators"), to: "/calculators" },
        { label: t("nav_guides"), to: "/guides" },
        { label: t("nav_pricing"), to: "/membership" },
      ],
    },
    {
      title: t("footer_company"),
      links: [
        { label: t("footer_about"), to: "/trust" },
        { label: t("nav_assistant"), to: "/assistant" },
        { label: t("footer_contact"), to: "/contact" },
      ],
    },
    {
      title: t("footer_legal"),
      links: [
        { label: t("footer_privacy"), to: "/privacy" },
        { label: t("footer_terms"), to: "/terms" },
        { label: t("footer_refund"), to: "/refund-policy" },
        { label: t("footer_trust"), to: "/trust" },
      ],
    },
  ];

  return (
    <footer className="border-t border-slate-200 bg-white" data-testid="footer">
      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Logo showTagline />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">
              {t("footer_mission")}
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1.5 text-xs font-medium text-emerald-700">
              <span className="h-2 w-2 rounded-full bg-emerald-500" />
              {t("status_operational")}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-wide text-slate-400">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="text-sm text-slate-600 hover:text-primary transition-colors" data-testid={`footer-link-${link.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-slate-200 pt-6">
          <p className="text-xs leading-relaxed text-slate-400">{t("footer_disclaimer")}</p>
          <div className="mt-4 flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-center">
            <p className="text-xs text-slate-400">© {year} EVERMIN. {t("footer_rights")}</p>
            <LanguageSwitcher />
          </div>
        </div>
      </div>
    </footer>
  );
}
